import React from 'react';

/**
 * ViewModeToggle Component
 * Toggle between table and card view (visible on all screen sizes)
 */
export default function ViewModeToggle({ mode, onChange }) {
  return (
    <div className="flex rounded-lg border border-gray-300 overflow-hidden">
      {/* Table view button */}
      <button
        onClick={() => onChange('table')}
        className={`px-3 py-2 flex items-center gap-1.5 text-sm font-medium transition-colors ${
          mode === 'table'
            ? 'bg-blue-600 text-white'
            : 'bg-white text-gray-600 hover:bg-gray-50'
        }`}
        title="Table view"
      >
        {/* Table icon */}
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
          />
        </svg>
        <span className="hidden sm:inline">Table</span>
      </button>

      {/* Card view button */}
      <button
        onClick={() => onChange('card')}
        className={`px-3 py-2 flex items-center gap-1.5 text-sm font-medium transition-colors ${
          mode === 'card'
            ? 'bg-blue-600 text-white'
            : 'bg-white text-gray-600 hover:bg-gray-50'
        }`}
        title="Card view"
      >
        {/* Card/Grid icon */}
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
          />
        </svg>
        <span className="hidden sm:inline">Cards</span>
      </button>
    </div>
  );
}
